export default /* html */ `
<div class="inner-wrapper">
  <div class="product-detail-wrapper">
    <div class="sold-out">
        <p>해당 상품은 현재 품절되었습니다.</p>
    </div>
    <div class="spinner-wrapper">
      <div class="spinner"></div>
    </div>
  <div class="thumbnail">
    <img src="" alt="" />
  </div>
  <div class="information-wrapper">
    <div class="top-information">
      <p class="product-title"></p>
      <div class="product-price-area">
      <div class="product-price"><span class="price-num"></span>원</div>
      <div class="discount-rate"><span class="price-num"></span>%</div>
      <div class="origin-price"><span class="price-num"></span>원</div></div>
      <div class="product-login-text">로그인 후 구매하실 수 있습니다.</div>
      <div class="product-quantity">
        <div class="title">수량 선택</div>
        <button class="down-button" disabled>-</button>
        <div class="count">1</div>
        <button class="up-button">+</button>
      </div>
    </div>
    <div class="low-information">
      <div class="price-information">
        <div class="description">총 상품금액</div>
        <div class="total-price"><span class="total-num"></span>원</div>
      </div>
      <div class="button-wrapper">
        <button class="wish-button">
        </button>
        <button class="cart-button">장바구니 담기</button>
      </div>
    </div>
  </div>
</div>
<div class="detail-img">
  <img src="/감자깡-상세페이지.jpeg" alt="상세페이지" />
</div></div>`;
